import { Component, OnInit, ChangeDetectorRef, ViewChild, ViewContainerRef, OnDestroy } from '@angular/core';
import {IConfigureWizard, IWorkflowStepComponent} from '@shared/interfaces/workflow-step.interface';
import { WorkflowModel, WorkflowState } from '../../../workflow/models/workflow.model';
import { Observable, Subject } from 'rxjs';
import { Store, select } from '@ngrx/store';
import { DataSurveyState } from '../../store/reducers/data-survey.reducers';
import { takeUntil } from 'rxjs/operators';
import { getCurrentSurvey } from '../../store/selectors/data-survey.selectors';
import { DialogModel } from '@shared/models/dialog.model';
import { DialogService } from '@shared/services/dialog-service';
import { StartSurveyCommand } from '../../commands/survey.commands';
import { GetSurveyAction } from '../../store/actions/data-survey.actions';
import { CommandService } from '@core/services/command.service';
import { SnackBarService } from '@core/services/snack-bar.service';
import {Guid} from 'guid-typescript';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {WorkflowWizardComponent} from '../../../workflow/components/workflow-wizard/workflow-wizard.component';
import {BasketProvider} from "@shared/models/basket-provider";
import {ParticleState} from "@shared/store/reducers/particle.reduer";
import {ChangeBasketAction} from "@shared/store/actions/particle.actions";
@Component({
    standalone: false,
    selector: 'particle-survey-data-step',
  templateUrl: './survey-data-step.component.html',
  styleUrls: ['./survey-data-step.component.scss']
})
export class SurveyDataStepComponent implements OnInit, IConfigureWizard,OnDestroy {

  currentStep: any;
  isClose = false;
  survey: any;
  private ngUnsubscribe = new Subject<void>();
  selectedFieldSectionIndex: number;
  selectedSection: any;
  sourceKey: string; // dummy
  currentSectionConfig: any;
  hasSelection: boolean;
  dataExecutionId: string;
  groupFilterKey: string;
  dataSelectionIds: any;
  invalidateSubject?: InvalidateSubject;
  invalidateSubjectList: InvalidateSubject[] = [];
  noOfSections = 10;
  private workflow: WorkflowModel;
  private wizard: WorkflowWizardComponent;
  private hasTabs: boolean;

  constructor(public changeDetectorRef: ChangeDetectorRef, private dataSurveyStore: Store<DataSurveyState>,
    private dialogService: DialogService,
    private particleStore: Store<ParticleState>,
    private commandService: CommandService,
    private snackBarService: SnackBarService) {
    this.sourceKey = 'DataSurveyExecution';
    this.hasSelection = false;
    for (let i = 0; i <= this.noOfSections; i++) {
      this.invalidateSubjectList = [...this.invalidateSubjectList, new InvalidateSubject()];
    }
   }

  ngOnInit() {
    this.dataSurveyStore.pipe(takeUntil(this.ngUnsubscribe), select(getCurrentSurvey)).subscribe(currentSurvey => {
      console.log('current survey:', currentSurvey);
      this.survey = currentSurvey;
      if (this.survey && this.survey.dataSections) {
        if (this.survey.dataSections.length) {
          this.onTabIndexChange(0);
          if (!this.dataExecutionId && this.survey && this.survey.dataSections) {
            this.dataExecutionId = Guid.create().toString();
            this.dataSelectionIds = {};
            this.survey.dataSections.forEach(f => {
              f.config['EXECUTION_ID'] = Guid.create().toString();
              this.dataSelectionIds[f.sectionId] = f.config['EXECUTION_ID'];
            });
          }
        } else {
          this.wizard.onNext();
          return;
        }
      }
    });
  }
  onLoad(workflow: WorkflowModel, currentStep: WorkflowState) {
    this.workflow = workflow;
    this.currentStep = currentStep;
  }
  onTabIndexChange(event) {
    this.selectedFieldSectionIndex = event;
    this.selectedSection = this.survey.dataSections[event];
    const sectionBasket = BasketProvider.getBasketBySourceType(this.selectedSection.sectionId);
    this.particleStore.dispatch(new ChangeBasketAction(sectionBasket));
    if (this.wizard.isWorkflowInLastState) {
      this.wizard.nextButtonCaption = this.selectedFieldSectionIndex === (this.survey.dataSections.length - 1) ? 'Finish' : 'Next';
    }
  }
  canMoveNext$(): Observable<boolean> {
    return null;
  }
  canMoveNext(): boolean {
    if (!this.survey.dataSections) {
      return true;
    }
    if (!this.dataSelectionIds || this.dataSelectionIds.length === 0) {
      return true;
    }
    if (this.selectedFieldSectionIndex < this.survey.dataSections.length - 1) {
      this.selectedFieldSectionIndex++;
      this.onTabIndexChange(this.selectedFieldSectionIndex);
      return false;
    }
    const filterInput = this.currentStep.Inputs.find(o => o.Name === 'Filters');
    if (filterInput && !filterInput.Arguments) {
      filterInput.Arguments = {};
    }
    Object.keys(this.dataSelectionIds).forEach(key => {
      filterInput.Arguments[key] = this.dataSelectionIds[key];
    });

    return true;
  }
  canCancel(): boolean {
    console.log('onBeforeCancel at WorkflowGridStepComponent');
    return true;
  }
  getCurrentSurvey() {
    this.dataSurveyStore.dispatch(new GetSurveyAction(this.survey.id));
  }



  onGridCellValueChange($event) {

  }
  selectWithoutData() {
    this.showSurveyExecutionSettinsDialog('WithoutData');
  }
  selectUsingGroupFilter() {
    this.showDataScopeDialog('Group Filter', 'StartSurveyUsingGroupFilterComponent', false, 'GroupFilter');
  }
  selectManually() {
    this.showDataScopeDialog('Select Data Manually', 'StartSurveyUsingManualDataSelectionComponent', true, 'ManualSelection');
  }

  showDataScopeDialog(title: string, componentName: string, isFullscreen: boolean, option: string) {
    const dialogModel: DialogModel = DialogModel.create(
      title,
      componentName, {'survey': this.survey },
      '600px',
      '1000px'
    );
    dialogModel.isFullscreen = isFullscreen;
    this.dialogService.showOkCancelDialog(dialogModel).pipe(takeUntil(this.ngUnsubscribe)).subscribe(res => {
      console.log('data scope:', res);
      if (res.action === 'OK') {
        if (option === 'GroupFilter') {
          this.groupFilterKey = res.data.input.groupFilterKey;
        }
       this.showSurveyExecutionSettinsDialog(option);
      }
    });
  }

  showSurveyExecutionSettinsDialog(option: string) {
    const dialogModel: DialogModel = DialogModel.create(
      'Settings',
      'SurveyExecutionSettingsComponent', {'survey': this.survey },
      '600px',
      '700px'
    );
    this.dialogService.showOkCancelDialog(dialogModel).pipe(takeUntil(this.ngUnsubscribe)).subscribe(res => {
      console.log('execution settings:', res);
      if (res.action === 'OK') {
        const input = res.data.input;
        const command = new StartSurveyCommand(input.survey.id,
          this.dataExecutionId,
          input.executionSettings.title,
          input.executionSettings.description,
          input.executionSettings.isCollaborative,
          input.executionSettings.canAddNewRecord,
          option
          );
        command.dataSelectionIds = this.dataSelectionIds;
        command.groupFilterKey = this.groupFilterKey;
        console.log('Command ', command);
        this.commandService.executeCommand(command).pipe(takeUntil(this.ngUnsubscribe)).subscribe(commandState => {
            console.log(commandState);
            this.hasSelection = true;
            this.wizard.hasTabs = true;
        });
      }
    });
  }

  getNextButtonCaption(isFinished: boolean): string {
    return isFinished && this.canMoveNext() ? 'Finish' : 'Next';
  }

  setWizard(wizard: WorkflowWizardComponent) {
    this.wizard = wizard;
  }

  onFieldSectionChanged($event: any) {
    console.log('onFieldSectionChanged at step', $event);
    this.hasTabs = $event && $event.length > 1;
    if (this.wizard) {
      this.wizard.hasTabs = this.hasTabs;
      console.log('Has Tabs', this.wizard.hasTabs);
    }
  }
  close() {
    this.isClose = true;
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
